import { useEffect } from 'react';
import moment from 'moment';

export default function useMomentLocale(props?: { dow?: number; doy?: number }) {
  const { dow = 0, doy = 6 } = props || {};

  /**
   * @date 2025-10-05
   * @description 页面临时配置moment的locale
   * @author lv.chen
   */
  useEffect(() => {
    // 保存原始locale配置
    const originalLocale = moment.locale();
    const originalLocaleData = moment.localeData();
    const originalWeekConfig = {
      // @ts-ignore
      dow: originalLocaleData._week?.dow,
      // @ts-ignore
      doy: originalLocaleData._week?.doy,
    };

    // 设置星期天为周的开始
    moment.updateLocale(originalLocale, {
      week: {
        // 星期天为周的第一天（0 = Sunday）
        dow,
        // 用于计算年度第一周
        doy,
      },
    });

    // 组件卸载时恢复原始配置
    return () => {
      moment.updateLocale(originalLocale, {
        week: originalWeekConfig,
      });
    };
  }, []);
}
